import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { StudyDayGenericType } from "api/generated";

import type { RootState } from "store/store";

import { dayNameToDayIndex } from "utils/calendarDateFormatting";

export interface TTimetableGenericDays {
  dayIndex: number;
  duration: number;
  startAt: string;
}

interface ITimetableState {
  genericTimetable: TTimetableGenericDays[];
}

const initialState: ITimetableState = {
  genericTimetable: [],
};

const timetableSlice = createSlice({
  name: "timetable",
  initialState,
  reducers: {
    setGenericTimetable: (state, action: PayloadAction<StudyDayGenericType[]>) => {
      const data = action.payload;
      const transformed: TTimetableGenericDays[] = [];

      for (let dayIndex = 1; dayIndex < 8; dayIndex++) {
        const initialDay = {
          dayIndex,
          duration: 0,
          startAt: "00:00",
        };
        transformed.push(initialDay);
      }

      for (const day of data) {
        const dayIndex = dayNameToDayIndex(day.dayName);
        if (dayIndex !== undefined) {
          transformed[dayIndex - 1] = {
            dayIndex,
            duration: day.duration ?? 0,
            startAt: day.startAt.split(":").slice(0, 2).join(":"),
          };
        }
      }
      state.genericTimetable = transformed;
    },
  },
});

export default timetableSlice.reducer;
export const { setGenericTimetable } = timetableSlice.actions;

export const selectGenericTimetable = (state: RootState) => state.timetable.genericTimetable;
